import { Component } from '@angular/core';

@Component({
  selector: 'lib-archive-creative-modal',
  template: `Are you sure you want to archive the selected creative(s) from your
  library? Archived creatives will not be selectable for use in future campaigns
  and will no longer show in the library. This will not impact any currently
  running campaigns. This action cannot be undone.`,
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ArchiveConfirmationModal {}
